import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button,FormGroup } from "react-bootstrap";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import 'components/sales/layoutChange/layout.css';
import './vendorstyle.css';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import FileUpload from "components/sales/fileUpload/fileUpload";
import * as moment from "moment";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from "react-toastify";



const PaymentInvoiceModification = ({
  getVendorRequestSubmit,
  getPaymentRequestDetails,
  getVendorPo,
  poDetail,
  getVendorDetails,
  invoiceModificationRequest,
  documentUploadUrl,
  documentUrlData,
  match,
  history,
}) => {
  const [teamId, setTeamId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isFocus1, setIsFous1] = useState(true);
  const [departmentId, setDepartmentId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [expenseBasis, setExpenseBasis] = useState('');
  const [allPart, setAllPart] = useState('All');
  const [gstType, setGSTType] = useState('IGST');
  const [retention, setRetention] = useState('No');
  const [checkDisable, setCheckDisable] = useState(true);
  const [isModal, setIsModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [isModalPO, setIsModalPO] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [sublob, setSubLob] = useState([]);
  const [searchRequest,setSearchRequest] = useState(null);
  const [respData, setRespData] = useState(null);
  
  //console.log(poDetail?.total_amount);
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [inputList, setInputList] = useState([{invoice_no:'',invoice_date:'',invoice_upload:'',payment_due_date:'',payment_mode:'All',expense_type:'',expense_basis:'',from_period:'',to_period:'',taxableAmt:'',po_no:'',po_amt:0,requestedAmt:0,totalAmount:0,cgst:'',sgst:'',igst:'',lob:'',retention_status:'No',retention_per:'',retention_amt:'',installation_id:'',project_name:'',installation_certificate:'',agreement_attachment:'',other_attachment:'',sub_lob:''}]);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);


  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (match?.params?.id) {
    
      (async () => {
        setIsLoading(true);
        await getPaymentRequestDetails(match?.params?.vendor_id);
        setIsLoading(false);
      })();
    
  }
  }, [getPaymentRequestDetails]);


  useEffect(() => {
    if (poDetail) {
      handleInputValue(poDetail.total_amount,'po_amt');
  }else{
        setIsModalPO(true);
  }
  }, [poDetail]);

  

  const handleInputValue = (val, key) => {
    // console.log(val);
    const list = [...inputList];
    list[0][key] = val;
    setInputList([...list]);
    console.log(inputList);
  };

  const setTotalAmt = (val) => {
    const list = [...inputList];
    console.log(list);

    var cgst = isNaN(list[0].cgst) ? 0 : list[0].cgst ;
    var freightAmt = isNaN(list[0].freightAmt) ? 0 : list[0].freightAmt ;
    var otherAmt = isNaN(list[0].otherAmt) ? 0 :list[0].otherAmt;
    var sgst = isNaN(list[0].sgst) ? 0 : list[0].sgst ;
    var taxableAmt = isNaN(list[0].taxableAmt) ? 0 : list[0].taxableAmt;
    var igst= isNaN(list[0].igst) ? 0 : list[0].igst;
    var totalAmt = Number(cgst)+Number(freightAmt)+Number(otherAmt)+Number(sgst)+Number(taxableAmt)+Number(igst);
    console.log(totalAmt);
    handleInputValue(totalAmt,'totalAmount');
  };

  const handleDateChange = (e, index, name) => {
    const current_datetime = moment(e).format("YYYY-MM-DD");
    const list = [...inputList];
    list[index][name] = current_datetime;
    setInputList(list);
  };

  const submitVendorReq = () =>{
    setIsLoading(true);
    if(match?.params?.id && inputList[0].invoice_date !='' && inputList[0].invoice_no !='' && inputList[0].payment_due_date !='' && inputList[0].payment_mode !='' && inputList[0].expense_type !='' && inputList[0].expense_basis !='' && inputList[0].from_period !='' && inputList[0].to_period !='' && inputList[0].taxableAmt !='' && inputList[0].totalAmount && inputList[0].invoice_upload != '' && inputList[0].lob != ''){
      // alert('a')
      if(inputList[0].expense_basis === 'PO'){
        // alert('b')
        var errMsg = '';
        var checkPO = 0;
        if(inputList[0].po_no === ''){
          errMsg = errMsg+'PO Number Is Required!<br/>';  
          checkPO = 1;
          
        }
        if(inputList[0].po_amt === 0 || inputList[0].po_amt === ''){
          errMsg = errMsg+'PO Amount Is Required!<br/>';  
          checkPO = 1;
        }
        if(checkPO == 1){
          setIsLoading(false);
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
      
          return false;
        }

      }
     
      if(inputList[0].cgst !=''){
        if(inputList[0].sgst =='' || inputList[0].igst !='' ){
          errMsg = 'Please Enter Correct GST!<br/>'; 
          setIsLoading(false);
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          return false;
        }
      }
      if(inputList[0].igst !=''){
        if(inputList[0].cgst == '' || inputList[0].sgst ==''){
          
        }else{
          errMsg = 'Please Enter Correct GST!<br/>'; 
          setIsLoading(false);
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          return false;
        }
      }
      if(inputList[0].igst =='' && inputList[0].cgst == '' && inputList[0].sgst ==''){
        
          errMsg = 'Please Enter Correct GST!<br/>'; 
          setIsLoading(false);
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          return false;
        
      }  

      if(inputList[0].igst =='Partial' && (inputList[0].requestedAmt == 0 || inputList[0].requestedAmt == '')){
        errMsg = 'Please enter requested amount!<br/>'; 
        setIsLoading(false);
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        return false;
      }
      
      (async () => {
        const data = inputList[0];
        //data['id'] = match?.params?.id;
        data['vendor_id'] = parseInt(match?.params?.vendor_id);
        data['request_id'] = parseInt(match?.params?.request_id);
        data['mod_status'] = parseInt(match?.params?.status);
        const res = await invoiceModificationRequest(data);
        if (res) {
          //console.log('0000 ' + res);
          setIsLoading(false);
          setSaveModal(true);
        }else{
          toast.error('Invoice not modified, try again.');
          setIsLoading(false);
        }
      })();
    }else{
      errMsg = 'Please enter data in required fields!<br/>'; 
      setIsLoading(false);
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        return false;
    }
   
    
  }

  const checkRequestedAmt = (val) => {
    const totalAmt = Number(inputList[0].totalAmount);
    if(totalAmt < Number(val)){
      setIsModal(true);
    }else{

    }
  };

  const changePaymentMode = (val) => {
    setAllPart(val)
    if(val === 'All'){
      handleInputValue(0,'requestedAmt');
    }else{

    }
  };
  
  const changeGstMode = (val) => {
    setGSTType(val);
    if(val === 'CGST'){
      handleInputValue('','igst');
    }else{
      handleInputValue('','cgst');
      handleInputValue('','sgst');
    }
  };
  
  const changeRetentoin = (val) =>{
    setRetention(val);
    if(val === 'Yes'){
      handleInputValue('5','retention_per');
    }else{
      handleInputValue('','retention_per');
    }
    
  };

  const handleModalHide = () => {
    // history.push(`${baseUrl}/postSalesListing`);
    handleInputValue(0,'requestedAmt');
    setIsModal(false);
  };
  const handleSaveModalHide = () => {
    history.push(`${baseUrl}/vendorPaymentRequestList`);
    setIsModal(false);
  };
  const handlePoModalHide = () => {
    
    setIsModalPO(false);
  };

  const handleErrorModal = () =>{
    setIsErrorModal(false);
  }
 
  const applySearchKey = async () => {
    if (match?.params?.id) {
    const searchKey = inputList[0].po_no;
    setIsLoading(true);
    await getVendorPo(match?.params?.id,searchKey);
    setIsLoading(false);
    }
  };

  const getSubLob = async (value) => {
    if(value) {
      setSubLob([]);
      const list = [...inputList];
      list[0]['sub_lob'] = '';
      setInputList(list);
      //console.log(inputList);
       const url = `${Config.preSalesList.getSubLob}?lob=${value}`;
       const { data } = await axios.get(url);
       if(data) {
          setSubLob(data);
       }
    }
  }

  useEffect(() =>  {
    handleInputValue(respData?.expense_basis,"expense_basis");
    setExpenseBasis(respData?.expense_basis);
    handleDateChange(respData?.invoice_date, 0,"invoice_date");
    handleDateChange(respData?.payment_due_date, 0,"payment_due_date");
    handleInputValue(respData?.invoice_number,"invoice_no");
    handleInputValue(respData?.expense_type,"expense_type");
    handleDateChange(respData?.from_date, 0,"from_period");
    handleDateChange(respData?.to_date, 0,"to_period");
    handleInputValue(respData?.description, 'description', 0);
    handleInputValue(respData?.lob,"lob");
    if(respData?.lob) {
     getSubLob(respData?.lob);
    }
    handleInputValue(respData?.sublob,"sub_lob");
    handleInputValue(respData?.taxable_amount,"taxableAmt");
    handleInputValue(respData?.other_charges,"otherAmt",0); 
    handleInputValue(respData?.installation_id, 'installation_id', 0);
    handleInputValue(respData?.project_name, 'project_name', 0);
    handleInputValue(respData?.retention_status, "retention_status");
    if(respData?.retention_status) {
      changeRetentoin(respData?.retention_status);
    }
    //handleInputValue(respData?.retention_per, 'retention_per', 0);
    if(respData?.igst && parseInt(respData?.igst) > 0) {
      let type = 'IGST';
      handleInputValue(type, "gst_type");
      changeGstMode(type);
      handleInputValue(respData?.igst, 'igst', 0);
      setTotalAmt(respData?.igst);
    } else {
      let type = 'CGST';
      handleInputValue(type, "gst_type");
      changeGstMode(type);
      handleInputValue(respData?.cgst, 'cgst', 0);
      setTotalAmt(respData?.cgst);
      handleInputValue(respData?.sgst, 'sgst', 0);
      setTotalAmt(respData?.sgst);
    }
    handleInputValue(respData?.po_number, 'po_no', 0);
    handleInputValue(respData?.po_amount, 'po_amt', 0);
    handleInputValue(respData?.invoice_upload, 'invoice_upload', 0);
    handleInputValue(respData?.installation_certificate, 'installation_certificate', 0);
    handleInputValue(respData?.agreement_attachment, 'agreement_attachment', 0);
  },[respData]);

  const applyRequestFilter = async () => {
    setIsLoading(true);
    const url = `${Config.preSalesList.getPaymentRequestData}?request_id=${searchRequest}&vendor_id=${match?.params?.vendor_id}`;
    const { data } = await axios.get(url);
    if(data && data?.response?.data?.length > 0) {
       toast.success('Invoice found against this request ID.');
       setRespData(data?.response?.data[0]);
    } else {
      toast.warning('No invoices were found against this request ID.');
    }
    setIsLoading(false);
  };

  useEffect(() => {
     if(match?.params?.request_id && match?.params?.request_id !== undefined) {
      (async () => {
        setIsLoading(true);
        const url = `${Config.preSalesList.getPaymentRequestData}?request_id=${match?.params?.request_id}&vendor_id=${match?.params?.vendor_id}`;
        const { data } = await axios.get(url);
        if(data && data?.response?.data?.length > 0) {
           //toast.success('Invoice found against this request ID.');
           setRespData(data?.response?.data[0]);
        } else {
          toast.warning('No invoices were found against this request ID.');
        }
        setIsLoading(false);
      })();  
     }
  },[match?.params?.request_id,match?.params?.vendor_id]);

  const handleInputChange = (e) =>{
    setSearchRequest(e.target.value);
  } 
  
  return (
    <Layout
      title={localization.modifyvendorPaymentRequest}
      isLoading={isLoading}
      searchOption={false}
      isGoback
      linkUrl={`${baseUrl}/vendorOnboardedList`}
    >
      <Fragment>
        {/* <div className="border border-primary rounded-10  searchBox" >
          <div className="input-group">
           <input type="search" className="form-control rounded borderColorBox" onChange={e => handleInputChange(e)} placeholder="Search Request" aria-label="Search" aria-describedby="search-addon" />
                  <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applyRequestFilter}>Search  </button>
          </div>
        </div>
        <br/> */}
        
        <div className="card border-round">
          <div className="card-header border-primary">
          {/* Payment Request */}
          <span className="vendorHeading"> Payment Request</span>
          <span style={{"float":'right'}}>
          <button className="btn btn-sm btn-success" onClick={() => setState({ isPaneOpen: true })}>
             Invoice & PO
            </button>
            </span>
            </div>
            <div className="fr-css">Finance Remark : {respData?.modification_remark}</div>
            <div className="card-body">
            <SlidingPane
              className="vendorSlider"
              overlayClassName="some-custom-overlay-class"
              isOpen={state.isPaneOpen}
              title="Hey, it is optional pane title.  I can be React component too."
              subtitle="Optional subtitle."
              width="400px"
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                setState({ isPaneOpen: false });
              }}
            >
              <div className="card">
                <div className="card-header skyblue">
                  Payment Request
                </div>
                <div className="card-body">
                  
                </div>
              </div>
              <div className="card">
                <div className="card-header skyblue">
                  PO Details
                </div>
                <div className="card-body">
                  
                </div>
              </div>
              
            </SlidingPane>
              <div className="row">
              <div className="col-md-4">
                  <ConstantInput
                      label={localization.vendorName}
                      type="text"
                      value={getVendorDetails?getVendorDetails.Vendor_details?.contact_person_name:""}
                     
                      required
                      disabled={true}
                      isStarRequired={true}
                    
                    />
                </div>
                <div className="col-md-4">
                  <ConstantInput
                      label={localization.vendorCode}
                      type="text"
                      value={getVendorDetails?getVendorDetails.Vendor_details?.vendor_code:""}
                     
                      required
                      disabled={true}
                      isStarRequired={true}
                    
                    />
                </div>
                <div className="col-md-4">
                  <ConstantInput
                      label={localization.vendorFirm}
                      type="text"
                      value={getVendorDetails?getVendorDetails.Vendor_details?.name_of_firm:""}
                     
                      required
                      disabled={true}
                      isStarRequired={true}
                    
                    />
                </div>
                </div>
                {/* <div className="h-divider"></div> */}
                <div className="row">
                <div className="col-md-4">
                  <DropDownInput
                    label="Select Type"
                    data={[
                      {
                        id: "PO",
                        name: "PO",
                      },
                      {
                        id: "NON PO",
                        name: "NON PO",
                      },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      handleInputValue(val.value, "expense_basis");
                      setExpenseBasis(val.value)
                    }}
                    disabled={true}
                    //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    // onChange={e => handleInputChange(e, i)}
                    isStarRequired={true}
                    value={respData?.expense_basis}
                  />
                </div>
                  <>
                    {expenseBasis === 'PO' ? (
                      <>
                      <div className="col-md-4">
                       

                        <div className="input-group">
                          <input type="search" className="form-control rounded borderColorBox" onChange={e =>  handleInputValue(e.target.value, 'po_no', 0)}  placeholder="PO Number" aria-label="Search" aria-describedby="search-addon" value={respData?.po_number} />
                          <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applySearchKey}>Search  </button>
                        </div>
                      </div>
                       <div className="col-md-4">
                      <ConstantInput
                          label={localization.poAmt}
                          type="text"
                          value={inputList[0].po_amt}
                          handleChange={(val) => {
                            handleInputValue(val, 'po_amt', 0);
                          }}
                          required
                          isStarRequired={true}
                          disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                          //value={respData?.po_amount}
                      />
                      </div>
                      </>
                    ):null}
                  </>
                <div className="col-md-4">
                  
                <FormGroup
                  className={`date custom_date_picker ${isFocus1 ? "active-date" : ""
                    }`}
                >
                  <label>
                    {localization.invoiceDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    
                    onChange={(e) => handleDateChange(e, 0,"invoice_date")}
                    
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={respData?.invoice_date}
                    disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.invoiceDate}
                    </label>
                  )}
                </FormGroup>
                </div>
                {/* paymentDueDate */}
                <div className="col-md-4">
                <FormGroup
                  className={`date custom_date_picker ${isFocus1 ? "active-date" : ""
                    }`}
                >
                  <label>
                    {localization.paymentDueDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    
                    onChange={(e) => handleDateChange(e, 0,"payment_due_date")}
                    
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={respData?.payment_due_date}
                    disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.paymentDueDate}
                    </label>
                  )}
                </FormGroup>
                </div>

                <div className="col-md-4">
                  <ConstantInput
                      label={localization.invoiceNo}
                      type="text"
                      //value={inputList.invoice_no}
                      handleChange={(val) => {
                        handleInputValue(val, 'invoice_no', 0);
                      }}
                      required
                      isStarRequired={true}
                      value={respData?.invoice_number}
                      disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    />
                </div>
                <div className="col-md-4">
                <FileUpload
                    id="invoice_upload"
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    onChange={(val) =>
                      handleInputValue(val, 'invoice_upload', 0)
                    }
                    prefilledFilename={respData?.invoice_upload}
                    disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                  >
                    <span className="btn btn-transparent">
                      {localization.uploadAttachment}
                    </span>
                  </FileUpload>
                </div>


                <div className="col-md-4">
                  <DropDownInput
                    label="Type Of Expense"
                    data={[
                      {
                        id: "Goods",
                        name: "Goods",
                      },
                      {
                        id: "Service",
                        name: "Service",
                      },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      handleInputValue(val.value, "expense_type");
                    }}
                    // onChange={e => handleInputChange(e, i)}
                    isStarRequired={true}
                    value={respData?.expense_type}
                    //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    // disabled={true}
                  />
                </div>



                {/* Period of Expense */}
                <div className="col-md-4">
                <FormGroup
                  className={`date custom_date_picker ${isFocus1 ? "active-date" : ""
                    }`}
                >
                  <label>
                    {localization.fromDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    
                    onChange={(e) => handleDateChange(e, 0,"from_period")}
                    
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={respData?.from_date}
                    // disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    disabled={true}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.fromDate}
                    </label>
                  )}
                </FormGroup>
                </div>
                {/* paymentDueDate */}
                <div className="col-md-4">
                <FormGroup
                  className={`date custom_date_picker ${isFocus1 ? "active-date" : ""
                    }`}
                >
                  <label>
                    {localization.toDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    
                    onChange={(e) => handleDateChange(e, 0,"to_period")}
                    
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={respData?.to_date}
                    //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    disabled={true}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.toDate}
                    </label>
                  )}
                </FormGroup>
                </div>


                <div className="col-md-4">
                  <ConstantInput
                      label={localization.description}
                      type="text"
                      //value={inputList.description}
                      handleChange={(val) => {
                        handleInputValue(val, 'description', 0);
                      }}
                      // required
                      maxLength={150}
                      // isStarRequired={true}
                      value={respData?.description}
                      //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                  
                />
                </div>

                {getVendorDetails && getVendorDetails.lob ? 
                    <div className="col-md-4">
                      <DropDownInput
                        label="Select LOB"
                        data={getVendorDetails.lob}
                        required
                        errorMsg={`Select LOB`}
                        getIdValue={(val) => {
                          handleInputValue(val.value, "lob");
                          getSubLob(val.value);
                        }}
                        // onChange={e => handleInputChange(e, i)}
                        isStarRequired={true}
                        value={respData?.lob}
                        //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                      />
                  </div>
                : null }
                {sublob && sublob?.length > 0 ? 
                    <div className="col-md-4">
                      <DropDownInput
                        label="Select Sub LOB"
                        data={sublob}
                        required
                        errorMsg={`Select Sub LOB`}
                        getIdValue={(val) => {
                          handleInputValue(val.value, "sub_lob");
                        }}
                        // onChange={e => handleInputChange(e, i)}
                        //isStarRequired={true}
                        value={respData?.sublob}
                        //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                      />
                  </div>
                : null }
                <div className="col-md-4">
                    <DropDownInput
                      label="Select Retention yes/no"
                      data={[
                        {
                          id: "Yes",
                          name: "Yes",
                        },
                        {
                          id: "No",
                          name: "No",
                        },
                      ]}
                      value={retention}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        handleInputValue(val.id, "retention_status");
                        changeRetentoin(val.id);
                      }}
                      // onChange={e => handleInputChange(e, i)}
                      isStarRequired={true}
                      // disabled={true}
                      //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    />
                  </div>
                { retention === 'Yes' ?
                  <div className="col-md-4">
                    <ConstantInput
                    label={localization.retentionPer}
                    type="number"
                    value={inputList[0].retention_per}
                    handleChange={(val) => {
                      handleInputValue(val, 'retention_per', 0);
                      setTotalAmt(val);
                    }}
                    required
                    isStarRequired={true}
                    //value={respData?.retention_per}
                    // disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                />
                  </div>
                : null}

                <div className="col-md-4">
                  <ConstantInput
                    label={localization.taxableAmt}
                    type="number"
                    //value={inputList.taxableAmt}
                    handleChange={(val) => {
                      handleInputValue(val, 'taxableAmt', 0);
                      setTotalAmt(val);
                    }}
                    required
                    isStarRequired={true}
                    value={respData?.taxable_amount}
                    // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                />
               </div>
               <div className="col-md-4">
                  <ConstantInput
                    label={localization.freightAmt}
                    type="number"
                    //value={inputList.freightAmt}
                    handleChange={(val) => {
                      handleInputValue(val, 'freightAmt', 0);
                      setTotalAmt(val);
                    }}
                    value={respData?.freight_amount}
                    // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    // required
                    // isStarRequired={true}
                  
                />
                </div>
                <div className="col-md-4">
                  <ConstantInput
                    label={localization.otherAmt}
                    type="number"
                    //value={inputList.otherAmt}
                    handleChange={(val) => {
                      handleInputValue(val, 'otherAmt', 0);
                      setTotalAmt(val);
                    }}
                    value={respData?.other_charges}
                    // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    // required
                    // isStarRequired={true}
                  
                />
                </div>
                <div className="col-md-4">
                    <DropDownInput
                      label="Select GST Type"
                      data={[
                        {
                          id: "CGST",
                          name: "CGST & SGST",
                        },
                        {
                          id: "IGST",
                          name: "IGST",
                        },
                      ]}
                      value={gstType}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        handleInputValue(val.id, "gst_type");
                        changeGstMode(val.id);
                      }}
                      // onChange={e => handleInputChange(e, i)}
                      isStarRequired={true}
                      // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    />
                  </div>
                <>
                {gstType === 'CGST' ? 
                  <>
                    <div className="col-md-4">
                    <ConstantInput
                      label={localization.cgst}
                      type="number"
                      value={inputList[0].cgst}
                      handleChange={(val) => {
                        handleInputValue(val, 'cgst', 0);
                        setTotalAmt(val);
                      }}
                      required
                      isStarRequired={true}
                      // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    
                  />
                  </div>
                  <div className="col-md-4">
                    <ConstantInput
                      label={localization.sgst}
                      type="number"
                      value={inputList[0].sgst}
                      handleChange={(val) => {
                        handleInputValue(val, 'sgst', 0);
                        setTotalAmt(val);
                      }}
                      required
                      isStarRequired={true}
                      // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    
                  />
                  </div>
                  </>
                : 
               
                  <div className="col-md-4">
                    <ConstantInput
                      label={localization.igst}
                      type="number"
                      value={inputList[0].igst}
                      handleChange={(val) => {
                        handleInputValue(val, 'igst', 0);
                        setTotalAmt(val);

                      }}
                      required
                      isStarRequired={true}
                      // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                    
                  />
                  </div>
                }
                </>
                
                <div className="col-md-4">
                  <ConstantInput
                    label={localization.totalAmountIncludeTax}
                    type="number"
                    value={inputList[0].totalAmount}
                    handleChange={(val) => {
                      handleInputValue(val, 'totalAmount', 0);
                    }}
                    required
                    isStarRequired={true}
                    // disabled={(parseInt(match?.params?.status) == 9) ? true : false}
                  
                />
                </div>

                <div className="col-md-4">
                  <ConstantInput
                    label={localization.projectId}
                    type="text"
                    //value={inputList.installation_id}
                    handleChange={(val) => {
                      handleInputValue(val, 'installation_id', 0);
                    }}
                    value={respData?.installation_id}
                    //required
                    //isStarRequired={true}
                    //disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    // disabled={true}
                  
                />
                </div>

                <div className="col-md-4">
                  <ConstantInput
                    label={localization.projectName}
                    type="text"
                    //value={inputList.project_name}
                    value={respData?.project_name}
                    handleChange={(val) => {
                      handleInputValue(val, 'project_name', 0);
                    }}
                    //required
                    //isStarRequired={true}
                    // disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    // disabled={true}
                  
                />
                </div>
                 
                <div className="col-md-4">
                <FileUpload
                    id="installation_certificate"
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    onChange={(val) =>
                      handleInputValue(val, 'installation_certificate', 0)
                    }
                    prefilledFilename={respData?.installation_certificate}
                    disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                  >
                    <span className="btn btn-transparent">
                      {localization.installationCertificate}
                    </span>
                  </FileUpload>
                </div> 

                <div className="col-md-4">
                <FileUpload
                    id="agreement_attachment"
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    onChange={(val) =>
                      handleInputValue(val, 'agreement_attachment', 0)
                    }
                    prefilledFilename={respData?.agreement_attachment}
                    disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                  >
                    <span className="btn btn-transparent">
                      {localization.agreementAttachment}
                    </span>
                  </FileUpload>
                </div>

                <div className="col-md-4">
                <FileUpload
                    id="other_attachment"
                    accept=".pdf,.png,.jpg,.jpeg,.doc,.xls,.xlsx,.msg"
                    multiple={true}
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    onChange={(val) =>
                      handleInputValue(val, 'other_attachment', 0)
                    }
                    disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                  >
                    <span className="btn btn-transparent">
                      {localization.otherAttachment}
                    </span>
                  </FileUpload>
                </div>

                </div>
                <div className="row" style={{display:'none'}}>
                  <div className="col-md-4">
                    <DropDownInput
                      label="Select Payment Mode"
                      data={[
                        {
                          id: "All",
                          name: "All Payment in One Request",
                        },
                        {
                          id: "Partial",
                          name: "Partially Payment",
                        },
                      ]}
                      value={`All Payment in One Request`}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        handleInputValue(val.id, "payment_mode");
                        changePaymentMode(val.id);
                      }}
                      // onChange={e => handleInputChange(e, i)}
                      isStarRequired={true}
                      disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                    />
                  </div>
                  <>
                  
                  {allPart === 'Partial' ?
                    <div className="col-md-4">
                      <ConstantInput
                          label={localization.requestedAmt}
                          type="text"
                          value={inputList[0].requestedAmt}
                          handleChange={(val) => {
                            handleInputValue(val, 'requestedAmt', 0);
                            checkRequestedAmt(val);
                          }}
                          required
                          isStarRequired={true}
                          disabled={(parseInt(match?.params?.status) == 8) ? true : false}
                        
                      />
                    </div>
                  :
                    null  
                    }
                  </>
                </div>
                <hr/>
                <div className="col-md-12">
                <Button  onClick={submitVendorReq}>
                    {localization.submitDtl} 
                  </Button>
                </div>
              {/* </div> */}
              
        </div>
        </div>
        <ModalPop
            title={localization.warning}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
            <div className="text-center">
              
                <img src={Images?.alert} alt="" />
             
              <h5>Requested amount should be less than or equal to total amount!</h5>
             
            
            </div>
          </ModalPop>
          <ModalPop
            title={localization.warning}
            show={isModalPO}
            handleModalHide={handlePoModalHide}
            keyboard
          >
            <div className="text-center">
              
                <img src={Images?.alert} alt="" />
             
              <h5>PO number is not exist in system. Please enter PO amount!</h5>
             
            
            </div>
          </ModalPop>
          <ModalPop
            title={localization.success}
            show={saveModal}
            handleModalHide={handleSaveModalHide}
            keyboard
          >
            <div className="text-center">
              
              <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
             
              <h5>Saved !</h5>
             
            
            </div>
          </ModalPop>
          
          <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleErrorModal}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
      </Fragment>

   </Layout>
  );
};

export default PaymentInvoiceModification;
